import { render, staticRenderFns } from "./linked-budget-request-view.vue?vue&type=template&id=34393e18"
import script from "./linked-budget-request-view.ts?vue&type=script&lang=ts&external"
export * from "./linked-budget-request-view.ts?vue&type=script&lang=ts&external"
import style0 from "./linked-budget-request-view.scss?vue&type=style&index=0&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('34393e18')) {
      api.createRecord('34393e18', component.options)
    } else {
      api.reload('34393e18', component.options)
    }
    module.hot.accept("./linked-budget-request-view.vue?vue&type=template&id=34393e18", function () {
      api.rerender('34393e18', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project-portfolio/linked-budget-request-view/linked-budget-request-view.vue"
export default component.exports